import React from 'react';

const MobileBottomNav = ({ activeView, onNavigate, unreadCount, taskCount }) => {
  const navItems = [
    { id: 'home', icon: '🏠', label: 'Home' },
    { id: 'tasks', icon: '✓', label: 'Tasks', badge: taskCount > 0 ? taskCount : null },
    { id: 'calendar', icon: '📅', label: 'Calendar' },
    { id: 'messages', icon: '💬', label: 'Messages', badge: unreadCount > 0 ? unreadCount : null },
    { id: 'notes', icon: '📝', label: 'Notes' }
  ];

  return (
    <div className="mobile-bottom-nav">
      {navItems.map(item => (
        <button
          key={item.id}
          className={`nav-item ${activeView === item.id ? 'active' : ''}`}
          onClick={() => onNavigate(item.id)}
        >
          <span className="icon">{item.icon}</span>
          <span className="label">{item.label}</span>
          {item.badge && <span className="nav-badge">{item.badge}</span>}
        </button>
      ))}
    </div>
  );
};

export default MobileBottomNav;
